import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

export const adminApi = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

adminApi.interceptors.request.use((config) => {
    const token = localStorage.getItem("ms_admin_token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const PACKAGE_IMAGES = {
    studio: "https://customer-assets.emergentagent.com/job_33166df8-b274-43e7-a60c-9b0f0b2ddb88/artifacts/t47n3jzv_PHOTO-2026-04-28-15-18-59.jpg",
    lounge: "https://customer-assets.emergentagent.com/job_33166df8-b274-43e7-a60c-9b0f0b2ddb88/artifacts/ympjbus1_PHOTO-2026-04-28-15-19-33.jpg",
};
